var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePurpleSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186.585,
    height: 149.646,
    viewBox: "0 0 186.585 149.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b7ce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "purple-pink__small",
    d: "M0,83.239A27.918,27.918,0,0,1,16.937,57.514C24.82,51.578,21.86,41.5,21.86,36.159,21.86,15.284,37.684,0,58.168,0c21.921.042,22.8,13.28,36.383,13.329q.149.207.285.419.2-.343.417-.661c7.562-1.013,17.117-11.237,29.874-11.237,21.49-.362,38.257,16.508,38.257,36.683a36.626,36.626,0,0,1-36.722,36.53c-5.263,0-13.78-.325-20.739,4.511-5.943,8.5-17.559,15.576-29.386,15.576-6.861,0-18.566-2.975-24.888,2.08A27.652,27.652,0,0,1,0,83.239Z",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 186.585, 107.359)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePurpleSmall);
export default __webpack_public_path__ + "static/media/blue-purple__small.2618422e27267f64e9ea234b422babe1.svg";
export { ForwardRef as ReactComponent };